// extracted by mini-css-extract-plugin
module.exports = {"balloon":"_7a3fb80146--balloon--zsPBk","icon":"_7a3fb80146--icon--m4Lji","route":"_7a3fb80146--route--uvGi5","route-button":"_7a3fb80146--route-button--G8rQA"};